import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Card from "antd/es/card/Card";
import CustomButton from "../../common/CustomButton";
import CustomInput from "../../common/CustomInput";
import { login } from "../../redux/actions/login";
import { notification } from "antd";

function CoordinatorLogin() {
  const [loginDetails, setLoginDetails] = useState({});
  const [isFirstTimeUser, setIsFirstTimeUser] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleClick() {
    if (!loginDetails?.username) {
      notification.error({
        message: "Validation Error",
        description: "Username is required!",
      });
      return;
    }

    if (isFirstTimeUser) {
      if (!loginDetails?.setPassword || !loginDetails?.confirmPassword) {
        notification.error({
          message: "Validation Error",
          description: "Set Password and Confirm Password are required!",
        });
        return;
      }

      if (loginDetails?.setPassword !== loginDetails?.confirmPassword) {
        notification.error({
          message: "Password Mismatch",
          description: "Passwords are not Matched",
        });
        return;
      }

      const payload = {
        username: loginDetails.username,
        password: loginDetails.setPassword,
        newUser: true,
      };

      const result = dispatch(login(payload));
      if (result) {
        navigate("/superadmin/home");
      }

    } else {
      if (!loginDetails?.password) {
        notification.error({
          message: "Validation Error",
          description: "Password is required!",
        });
        return;
      }

      const payload = {
        username: loginDetails.username,
        password: loginDetails.password,
      };

      dispatch(login(payload, navigate));
    }
  }


  return (
    <div style={{ ...divAlignCenter, height: "100vh" }}>
      <Card
        title="Coordinator Login"
        style={{ width: "40%"}}
        actions={[
          <div style={divAlignCenter}>
            <CustomButton title={"Login"} onClick={handleClick} />
          </div>,
        ]}
      >
        <CustomInput
          label={"User Name"}
          placeholder="User Name"
          value={loginDetails?.username}
          onChange={(e) =>
            setLoginDetails({ ...loginDetails, username: e.target.value })
          }
          style={{ marginBottom: 10 }}
        />

        {isFirstTimeUser ? (
          <>
            <CustomInput
              label={"Set Password"}
              placeholder="Set Password"
              type="password"
              value={loginDetails?.setPassword}
              onChange={(e) =>
                setLoginDetails({ ...loginDetails, setPassword: e.target.value })
              }
              style={{ marginBottom: 10 }}
            />
            <CustomInput
              label={"Confirm Password"}
              placeholder="Confirm Password"
              type="password"
              value={loginDetails?.confirmPassword}
              onChange={(e) =>
                setLoginDetails({
                  ...loginDetails,
                  confirmPassword: e.target.value,
                })
              }
              style={{ marginBottom: 10 }}
            />
          </>
        ) : (
          <CustomInput
            label={"Password"}
            placeholder="Password"
            type="password"
            value={loginDetails?.password}
            onChange={(e) =>
              setLoginDetails({ ...loginDetails, password: e.target.value })
            }
            style={{ marginBottom: 10 }}
          />
        )}

        <div>
          <input
            type="checkbox"
            checked={isFirstTimeUser}
            onChange={() => setIsFirstTimeUser(!isFirstTimeUser)}
          />
          <label style={{ marginLeft: 10 }}>First Time User?</label>
        </div>
      </Card>
    </div>
  );
}

const divAlignCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export default CoordinatorLogin;
